export function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message
  return String(error)
}

export function isError(error: unknown) {
  return error && !!(error as { message: string }).message
}
